export function trackLoginSuccess(searchParams) {
  const visitorId = localStorage.getItem("visitorId");
  const utmSource =
    searchParams.get("utm_source") || localStorage.getItem("utmSource");
  const utmMedium =
    searchParams.get("utm_medium") || localStorage.getItem("utmMedium");
  const utmCampaign =
    searchParams.get("utm_campaign") || localStorage.getItem("utmCampaign");

  if (visitorId && utmCampaign) {
    fetch("https://webhook-whatsapp.eduassistance.co/api/tracking/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        visitorId,
        utmSource,
        utmMedium,
        utmCampaign,
        eventType: "LOGIN_SUCCESS",
      }),
    }).catch((err) => console.error("Tracking error", err));
  }
}

export function trackPwaInstall() {
  if (localStorage.getItem("pwa_install_tracked")) {
    return;
  }

  const visitorId = localStorage.getItem("visitorId");
  const params = new URLSearchParams(window.location.search);
  const utmSource =
    params.get("utm_source") || localStorage.getItem("utmSource");
  const utmMedium =
    params.get("utm_medium") || localStorage.getItem("utmMedium");
  const utmCampaign =
    params.get("utm_campaign") || localStorage.getItem("utmCampaign");

  if (visitorId && utmCampaign) {
    fetch("https://webhook-whatsapp.eduassistance.co/api/tracking/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        visitorId,
        utmSource,
        utmMedium,
        utmCampaign,
        eventType: "PWA_INSTALL",
      }),
    }).then(() => {
      localStorage.setItem("pwa_install_tracked", "true");
    }).catch((err) => console.error("Tracking error", err));
  }
}
